import { format, parseISO } from 'date-fns';

const formatDate = (dateISO: string) => {
  if (dateISO) return format(parseISO(dateISO), 'd MMM y, H:mm');

  return 'N/A';
};

export default formatDate;
